import { useMemo, useState } from "react";
import { useCookie, useLocalStorage } from "react-use";

const useUserInformation = () => {
  const [localStorageBrowser, setLocalStorageBrowser] =
    useLocalStorage("__react_session__");

  const [tokenCookie, setTokenCookie, deleteToken] =
    useCookie("_token_avaex_agent");

  const [isAuth, setIsAuth] = useState(tokenCookie ? true : false);
  const [isAgent] = useState(localStorageBrowser?.user?.IsAgent ? true : false);
  const [isSupervisor] = useState(
    localStorageBrowser?.user?.supervisor ? true : false
  );
  const [isDistrictManger] = useState(
    localStorageBrowser?.user?.district_manager ? true : false
  );

  const [isDigikalaCoworker] = useState(
    localStorageBrowser?.user?.digikala_coworker ? true : false
  );

  const setStorage = (data, clear = false) => {
    setLocalStorageBrowser(cur => {
      if (clear === true) {
        return { ...data };
      }

      return { ...cur, ...data };
    });
  };

  const getStorage = name => {
    try {
      return localStorageBrowser[name];
    } catch (error) {
      return undefined;
    }
  };

  const clearStorage = () => {
    setLocalStorageBrowser();
  };

  const setToken = (value = "", options = undefined) => {
    let time = "";

    if (options === undefined) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      now.setDate(now.getDate() + 6);
      time = now;
    }

    setTokenCookie(value, options === undefined ? { expires: time } : options);
  };

  useMemo(() => {
    if (isAuth === false && getStorage("user") !== undefined) {
      window.localStorage.clear();
      window.sessionStorage.clear();
    } else if (isAuth === true && getStorage("user") === undefined) {
      deleteToken();
      window.localStorage.clear();
      window.sessionStorage.clear();
      setIsAuth(() => false);
    }
  }, []);

  return {
    setStorage,
    getStorage,
    clearStorage,
    token: tokenCookie,
    setToken,
    user: getStorage("user"),
    agent: getStorage("agent"),
    isAuth,
    isAgent,
    deleteToken,
    isSupervisor,
    isDistrictManger,
    isDigikalaCoworker,
  };
};

export default useUserInformation;
